import React from "react";
import { FiSearch, FiRefreshCw, FiArrowLeft } from "react-icons/fi";

interface ChatSearchProps {
  value: string;
  onChange: (value: string) => void;
  onRefresh?: () => void;
  onBack?: () => void;
  hasSelectedChat?: boolean;
}

export const ChatSearch: React.FC<ChatSearchProps> = ({
  value,
  onChange,
  onRefresh,
  onBack,
  hasSelectedChat,
}) => {
  return (
    <div className="flex items-center gap-2 px-3 py-3 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 md:py-5 lg:py-5">
      <div className="relative flex-1">
        <FiSearch
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          size={18}
        />
        <input
          type="text"
          placeholder="Pesquisar conversas..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full pl-10 pr-3 py-2.5 bg-gray-100 dark:bg-gray-700 rounded-lg text-sm outline-none focus:ring-2 focus:ring-purple-400 dark:text-white transition-all md:py-2 md:pr-4"
        />
      </div>
      {hasSelectedChat && onBack && (
        <button
          onClick={onBack}
          className="p-2.5 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-500 dark:text-gray-400 transition-all active:scale-95 md:p-2"
          title="Voltar para o Dashboard"
        >
          <FiArrowLeft size={20} className="md:text-[18px]" />
        </button>
      )}
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="p-2.5 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-500 dark:text-gray-400 transition-all active:scale-95 md:p-2"
          title="Atualizar conversas"
        >
          <FiRefreshCw size={20} className="md:text-[18px]" />
        </button>
      )}
    </div>
  );
};
